import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../api/api'
import { AUTH_CONFIG } from "../../auth/config";
const initialState = {
    profile: null,
    loading: false,
    error: '',
}
export const profileAsync = createAsyncThunk('profile', async () => {
    try {
        const profile = await api.get(AUTH_CONFIG.requests.profile.url)
          if (profile.data.code === 1006 ) {
            return profile.data.result
          }
         
    } catch (error) {
        throw error
    }
})

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        
    },
    extraReducers: {
        [profileAsync.pending]: (state, action) => {
            state.loading = true
            state.error = ''
        },
        [profileAsync.fulfilled]: (state, action) =>{
            state.profile = action.payload
            state.loading = false
            state.error = ''
        },
        [profileAsync.rejected]: (state, action) => {
            state.profile = null
            state.loading = false
            state.error = action.error.message
        }
    },
})
export default profileSlice.reducer